import { Badge } from 'framework/ui/mui-builder';

type FilterChipProps = {
  label: string;
  count?: string;
  isActive?: boolean;
  title?: string;
  onClick: () => void;
};

const FilterChip = ({ label, count, isActive = false, title, onClick }: FilterChipProps) => (
  <Badge
    clickable
    title={title}
    aria-pressed={isActive}
    color={isActive ? 'primary' : 'default'}
    variant={isActive ? 'filled' : 'outlined'}
    sx={{ marginLeft: 0 }}
    onClick={onClick}
  >
    {label}
    {count ? (
      <span style={{ marginLeft: 6, opacity: isActive ? 0.85 : 0.6, fontVariantNumeric: 'tabular-nums' }}>{count}</span>
    ) : null}
  </Badge>
);

export default FilterChip;
